import { render, staticRenderFns } from "./privateAssets.vue?vue&type=template&id=1ea67b5e"
import script from "./privateAssets.vue?vue&type=script&lang=js"
export * from "./privateAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports